export const SET_EDITOR_PREFERENCES = 'SET_EDITOR_PREFERENCES';

const setEditorPreferences = (state, payload = {}) => {
  const current = state.editorPreferences || {};
  const next = { ...current, ...payload };

  const unchanged = Object.keys(next).every((key) => next[key] === current[key]);
  if (unchanged) {
    return state;
  }

  return {
    ...state,
    editorPreferences: next,
  };
};

export default setEditorPreferences;
